import { AdminLayout } from '@/modules/common/layouts/AdminLayout';
import { TransactionsPage } from '@/modules/learning-budgets/pages/TransactionsPage';
import { CustomDateInterval } from '@/modules/learning-budgets/types';

import {
  LearningBudgetTransactionLabel,
  LearningBudgetTransactionStatus,
} from '@/types/learning-budget';
import { createFileRoute } from '@tanstack/react-router';
import * as yup from 'yup';

export type LearningBudgetTransactionsRouteQueryParams = {
  teamId?: string | string[];
  userId?: string;
  userName?: string;
  page?: number;
  limit?: number;
  dateInterval?: CustomDateInterval;
  status?: LearningBudgetTransactionStatus[];
  initialDate?: string;
  finalDate?: string;
  labels?: LearningBudgetTransactionLabel[];
};

export const Route = createFileRoute('/_admin/learning-budgets/transactions')({
  validateSearch: search => {
    return yup
      .object({
        page: yup.number().integer().min(1).optional(),
        limit: yup.number().integer().min(1).optional(),
        teamId: yup.lazy(value => {
          if (Array.isArray(value)) {
            return yup.array().of(yup.string().uuid());
          }
          return yup.string().uuid();
        }),
        userId: yup.string().uuid().optional(),
        status: yup
          .array()
          .of(
            yup.string().oneOf(Object.values(LearningBudgetTransactionStatus)),
          )
          .optional(),
        userName: yup.string().optional(),
        dateInterval: yup
          .string()
          .oneOf(Object.values(CustomDateInterval))
          .optional(),
        initialDate: yup.string().optional(),
        finalDate: yup.string().optional(),
      })
      .test(
        'teamIdOrUserId',
        'either teamId or userId is required, not both',
        value => {
          if (value.teamId && value.userId) {
            return false;
          }
          return true;
        },
      )
      .noUnknown()
      .validateSync(search);
  },
  component: () => {
    return (
      <AdminLayout>
        <TransactionsPage />
      </AdminLayout>
    );
  },
});
